import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.1716 6.1716A4 4 0 0 1 10 5h4a1 1 0 0 1 .0431.001 4 4 0 0 1 3.6 2.6666c.1836.5209-.0898 1.092-.6107 1.2755-.5209.1836-1.092-.0898-1.2755-.6107A2 2 0 0 0 13.9762 7H10a2 2 0 1 0 0 4h4a4 4 0 0 1 2.8284 1.1716 3.9996 3.9996 0 0 1 0 5.6568A4 4 0 0 1 14 19h-4a1 1 0 0 1-.0431-.0009 4 4 0 0 1-3.6-2.6667c-.1836-.5209.0898-1.092.6107-1.2755.5209-.1836 1.092.0898 1.2755.6107A2 2 0 0 0 10.0238 17H14a2 2 0 0 0 0-4h-4a4 4 0 0 1-4-4 4 4 0 0 1 1.1716-2.8284",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1V3c0-.5523.4477-1 1-1m0 15c.5523 0 1 .4477 1 1v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3c0-.5523.4477-1 1-1",
        clipRule: "evenodd"
    }, "1")
], "CurrencyDollar", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
